module.exports = __webpack_public_path__ + "img/Icon awesome-map-marker-alt.53f8ba1c.svg";